import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'shell-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  @Input() error_identity: boolean;
  constructor() {}

  ngOnInit(): void {}
}
